// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"vK-z","carouselContainer":"wK-z"};